export class Enums {
  constructor(obj) {
    Object.keys(obj).forEach(key => {
      this[key] = obj[key];
      this[obj[key]] = key;
    });
  }

  map(keys) {
    return keys.map(x => this[x]);
  }
}

export let planTypes = {
  WEBINAR: 'webinar',
  ZOOM_ROOMS: 'zoomroom',
  ZOOM_PHONE: 'pbx',
  ROOM_CONNECTOR: 'rc',
  LARGE_MEETING: 'large_meeting',
  TOLLFREE: 'tollfree',
  TOLLFREE$DID: 'tollfree$did',
  CMR: 'cmr',
  ZOOM_MEETING: 'zoom_meeting',
  API: 'api',
  ZOOM_UNITED: 'zoomunited',
  VIDEO_SDK: 'video_sdk',
  ZOOM_HARDWARE: 'zoom_hardware',
  HIPAA_COMPLIANCE: 'hipaa_compliance',
  PREMIER: 'premier',
  PAID_DEVELOPER: 'paid_developer',
  ZOOM_EVENTS: 'zoom_events',
  WEBINAR_PROMO: 'webinar_promo',
  FREE_TRIAL: 'free_trial',
  QSS: 'quality_streaming_service',
  ZOOM_NODE: 'zoom_node',
  ZOOM_CONTACT_CENTER: 'zcc',
  PHONE_NUMBER: 'pnm',
  ZOOM_IQ: 'zoom_iq',
  MIO: 'mio',
  ZOOM_WHITEBOARD: 'whiteboard',
  ZOOM_WHITEBOARD_PLUS: 'whiteboard_plus',
  ZOOM_ONE: 'zoomone',
  ZOOM_CHAT: 'zoom_chat',
  ZOOM_ONE_BUNDLE: 'zonebundle',
  TRANSLATION_CAPTIONS: 'translation_captions',
  VIDEO_SDK_TRANSLATION: 'video_sdk_translation',
  ZOOM_ROOM_HARDWARE: 'zr_hardware',
  ZOOM_PHONE_HARDWARE: 'pbx_hardware',
  WORKSPACE_RESERVATION: 'workspace_reservation',
  CMK: 'cmk',
  LDKCMR: 'videosdk_cmr',
  ZOOM_MESH: 'zoom_mesh',
  EVENT_SAAS: 'eventsaas',
  EVENT_SAAS_CORE: 'eventsaascore',
  ADDITIONAL_HOST: 'additional_host',
  ADDITIONAL_CO_EDITOR: 'additional_co_editor',
  ZVA: 'zva',
  Bundle_CREDIT: 'bundleCredit',
  LDKCRC: 'video_sdk_crc',
  API_CSP: 'api_csp',
  ZSU: 'ZSU',
  ZOOM_SCHEDULER: 'zsched',
  ZONE_BASIC_PLUS: 'zone_basic_plus',
  ZONE_PPM: 'zone_ppm',
  MASTER_CLASS: 'masterclass',
  ZOOM_CLIPS: 'zoom_clips',
  VIDEO_SDK_UC: 'video_sdk_uc',
};

planTypes = new Enums(planTypes);

export const flowTypes = {
  addTrial: 'add_trial',
  buyTrial: 'buy_trial',
  basic2trial: 'basic2trial',
  trial2paid: 'trial2paid',
  buyNow: 'buyNow',
  basic2pro: 'basic2pro',
  edit: 'edit',
  add2cart: 'add2cart',
  pro2biz: 'pro2biz',
  downgrade: 'downgrade',
  upgrade: 'upgrade',
};

export const freeTrialPrefixKey = 'OL-FT-';

export const TRAIL_CONDITION_TYPE = {
  qualify: 'qualify',
  non_qualify: 'non_qualify',
  trialling: 'trialling',
  trial_expired: 'trial_expired',
  isInEligible(status) { // Do not meet the conditions for purchasing free trial plan
    return this.non_qualify === status;
  },
  isEligible(status) { // Meet the conditions for purchasing free trial plan
    return this.qualify === status;
  },
  isTrialing(status) { // Free trial plan is still in using
    return this.trialling === status;
  },
  isTrialExpired(status) { // Free trial plan has expired
    return this.trial_expired === status;
  },
};

export const BILLING_CYCLE_CONSTANT = {
  ONE_TIME: 'one_time',
  ONE_MONTH: 'one_month',
  MONTHLY: 'monthly',
  QUARTERLY: 'quarterly',
  ANNUAL: 'annual',
  TWO_YEARS: 'two_years',
  THREE_YEARS: 'three_years',
  PAY_AS_YOU_GO: 'payAsYouGo',
  PAY_PER_ATTENDEE: 'attendee',
};

export const BILLING_CYCLE = {
  1: BILLING_CYCLE_CONSTANT.MONTHLY,
  3: BILLING_CYCLE_CONSTANT.QUARTERLY,
  12: BILLING_CYCLE_CONSTANT.ANNUAL,
  24: BILLING_CYCLE_CONSTANT.TWO_YEARS,
  36: BILLING_CYCLE_CONSTANT.THREE_YEARS,
};

export const defaultBillingCycle = 'monthly';
export const defaultPlanCategory = 'pro';
export const support_all = 'all';

export const SALES_CHANNEL = {
  online: 'online',
  direct: 'direct',
}

export const salesChannelList = [SALES_CHANNEL.online, SALES_CHANNEL.direct];

export let AccountTypeEnum = {
  ACCOUNT_UNKNOWN: 0,
  ACCOUNT_FREE_WITH_CC: 1,		// free with CC
  ACCOUNT_FREE_WITHOUT_CC: 2, 	// free without CC, default account type
  ACCOUNT_PAID: 3, 				// named host <10
  ACCOUNT_ACTIVE_HOST: 4, 		// active host
  ACCOUNT_APP_PARTNER: 5,		// API partner
  ACCOUNT_EDU_HOST: 6,			// edu name host
  ACCOUNT_NAME_HOST_50_UP: 7,	// name host 10+
  ACCOUNT_FREE_TRIAL: 8,			// free trial
  ACCOUNT_VIP: 9,				// VIP
  ACCOUNT_BULK_LICENSE: 10,		// BULK License, other rights like ACCOUNT_PAID
  ACCOUNT_ZOOM_ROOM: 11,		// ZOOM room
  ACCOUNT_LITE_SDK: 12,          // video sdk
  ACCOUNT_ZOOM_PHONE: 18,		// ZOOM Phone
};

AccountTypeEnum = new Enums(AccountTypeEnum);

export const BASE_PLAN_CATEGORY_MAP = {
  PRO: 'pro',
  BIZ: 'biz',
  BIZ_INR: 'biz_inr',
  EDUCATION: 'education',
  ENTERPRISE: 'bundle',
  ENT: 'ent',
  EDU: 'edu',
  EDU_SITE: 'edu_site',
  HC_PRO: 'hc_pro',
  HC_BIZ: 'hc_biz',
  ZOOM_ONE_BIZ_FOR_GOV: 'zone_biz_for_gov',
  ZOOM_ONE_PRO_PLUS: 'zone_proplus',
  ZOOM_ONE_BIZ_PLUS: 'zone_bizplus',
  ZOOM_ONE_ENTERPRISE: 'zone_enterprise',
  ZOOM_ONE_ENTERPRISE_PLUS: 'zone_enterprise_plus',
  WHITEBOARD_BASIC: 'zwbbasic',
  WHITEBOARD_PLUS: 'zwbplus',
};

export const TRIAL_TYPE = {
  service: 1,
  plan: 2
}
